export default "__VITE_ASSET__GMR2VVGq__"